import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import { FiUpload } from "react-icons/fi";

const UploadCsv = ({ csvArray }) => {
    const [csvFile, setCsvFile] = useState();

    const processCSV = (str, delim=';') => {
        const data = str.split('\n')

        const newArray = data.map( row => {
            const newLine = {
              number: row.split(delim)[0]?.includes('\r') ? row.split(delim)[0].replace('\r', '') : row.split(delim)[0],
              name: row.split(delim)[1]?.includes('\r') ? row.split(delim)[1].replace('\r', '') : row.split(delim)[1],
              email: row.split(delim)[2]?.includes('\r') ? row.split(delim)[2].replace('\r', '') : row.split(delim)[2],
              desc: row.split(delim)[3]?.includes('\r') ? row.split(delim)[3].replace('\r', '') : row.split(delim)[3]
            }
            return newLine
        })
        csvArray(newArray)
    }

    const submit = () => {
        const file = csvFile;
        const reader = new FileReader();

        reader.onload = function(e) {
            const text = e.target.result;
            processCSV(text)
        }
        reader.readAsText(file);
    }

    return (
      <>
        <Grid container style={{justifyContent: "center", flexDirection: "column", alignItems:"center", height:'200px'}}>
            <Grid className="text-center">
                <FiUpload className="font-size-36 text-grey mb-10"/>
            </Grid>
            <Grid className="text-center">
                <h1 className="font-size-12 text-grey reguler">klik disini untu mengunggah file</h1>
            </Grid>
            <Grid container justify="center" style={{ marginTop: 5 }}>
            {/* <input
                style={{ display: "none" }}
                type="file"
                accept="image/jpeg, image/png"
                onChange={this.fileSelectedHandler}
                ref={fileInput => (this.fileInput = fileInput)}
            /> */}
            <form id='csv-form'>
            <input
                type='file'
                accept='.csv'
                id='csvFile'
                onChange={(e) => {
                    setCsvFile(e.target.files[0])
                }}
            >
            </input>
            <br/>
            <button
                onClick={(e) => {
                    e.preventDefault()
                    if(csvFile)submit()
                }}
            >
                Submit
            </button>
        </form>
            </Grid>
        </Grid>
      </>
    );
}

export default UploadCsv;